// src/reducer.js
import * as actionTypes from './actionTypes';

const initialState = {
  allData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_DISCOUNT:
      return {
        ...state,
        allData: {
          ...state.allData,
          discount: action.payload,
        },
      };
    case actionTypes.SET_CURRENT_PRODUCT_DETAIL:
      state = {
        ...state,
        allData: action.payload,
      };
      break;
    case actionTypes.REMOVE_CURRENT_PRODUCT_DETAIL:
      state = { allData: [] };
      break;
    case actionTypes.GROSS_AMOUNT_UPDATE:
      state = {
        ...state,
        allData: {
          ...state.allData,
          grossAmount: action.payload,
        },
      };
      break;
    default:
      state = { ...state };
  }
  return state;
};

export default reducer;
